import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingService } from '../../services/loading/loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  loading = new Observable<boolean>();

  constructor(private loadingService: LoadingService) {
    this.loading = this.loadingService.loadingStatus$;
  }
}
